import React, { useState } from "react";
import { Header } from "../components/Header";
import { Button, Col, Container, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment-timezone';
import { Footer } from "../components/Footer";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import XLSX from "xlsx-js-style";
const BookingReport = () =>{
    moment.tz.setDefault("Asia/Ho_Chi_Minh");

    const [bookingList, setBookingList] = useState([]);
    const headers = [
        { label: 'Công ty', key: 'organisation_name' },
        { label: 'Mã hợp đồng khám', key: 'health_contract_code' },
        { label: 'Hợp đồng khám', key: 'health_contract_name' },
        { label: 'PID', key: 'person_code' },
        { label: 'STT', key: 'seq_number' },
        { label: 'Họ và tên', key: 'full_name' },
        { label: 'Số điện thoại', key: 'phoneNumber' },
        { label: 'Ngày sinh', key: 'date_of_birth' },
        { label: 'Nơi làm việc/chức vụ', key: 'place_of_work_l' },
        { label: 'Cơ sở khám', key: 'facility_number' },
        { label: 'Ngày khám', key: 'expect_date' },
        { label: 'Buổi', key: 'day_part' },
        { label: 'Ngày đặt lịch', key: 'last_update' },
        { label: 'Người đi cùng', key: 'relative_name' },
        { label: 'Các yêu cầu khác', key: 'out_of_packages' },        
      ];

    const columns = [{
        dataField: 'organisation_name',
            text: 'Công ty'
        }, {
            dataField: 'health_contract_code',
            text: 'Mã hợp đồng khám'
        }, {
            dataField: 'health_contract_name',
            text: 'Hợp đồng khám'
        },
        {
            dataField: 'person_code',
            text: 'PID'
        },
        {
            dataField: 'seq_number',
            text: 'STT'
        },
        {
            dataField: 'full_name',
            text: 'Họ và tên'
        },
        {
            dataField: 'phoneNumber',
            text: 'Số điện thoại'
        },
        {
            dataField: 'date_of_birth',
            text: 'Ngày sinh'
        },
        {
            dataField: 'place_of_work_l',
            text: 'Nơi làm việc/chức vụ'
        },
        {
            dataField: 'facility_number',
            text: 'Cơ sở khám'
        },        
        {
            dataField: 'expect_date',
            text: 'Ngày khám',            
        },
        {
            dataField: 'day_part',
            text: 'Buổi'
        },
        {
            dataField: 'last_update',
            text: 'Ngày đặt lịch'
        },
        {
            dataField: 'relative_name',
            text: 'Người đi cùng'
        },
        {
            dataField: 'out_of_packages',
            text: 'Các yêu cầu khác'
        },   
];


    const [person_code, setPersonCode] = useState('');
    const [fullName, setFullName] = useState('');
    const [facility_number, setFacility_number] = useState('0');
    
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const onDateChanges = (dates) => {
        const [start, end] = dates;
        setFromDate(start);
        setToDate(end);
    };
    
    const isWeekday = (date) => {
		const day = date.getDay();
		return day !== 0;
	};

    const findBooking = (e) =>{
        e.preventDefault();
        setBookingList([]);
        var data = JSON.stringify({
            person_code,
            fullName,
            fromDate: moment(fromDate).format('yyyy-MM-DD'),
            toDate: moment(toDate).format('yyyy-MM-DD'),
            facility_number,
            username: userAccount.username,
        });

        fetch(
			'https://booking.bernard.vn/api/Calendar/findBookings', { method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: data }
		)
		.then(async response => {
			if(response.ok){
				const isJson = response.headers.get('content-type')?.includes('application/json');
				const result = isJson ? await response.json() : null;
                
                result.forEach(element => {
                    element['date_of_birth'] = moment(element['date_of_birth']).format('DD/MM/yyyy');
                    element['expect_date'] = moment(element['expect_date']).format('DD/MM/yyyy');
                    element['last_update'] = moment(element['last_update']).format('DD/MM/yyyy');
                });
                setBookingList(result);                
            }
        });
    };

    const handleExport = () => {
        
        const wb = XLSX.utils.book_new();
        const wsData = [
          headers.map((header) => header.label), // Column headers
          ...bookingList.map((row) => headers.map((header) => row[header.key])), // Data rows
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Calculate column widths
        const columnWidths = [];
        for (let i = 0; i < headers.length; i++) {
        let maxWidth = headers[i].label.length; // Start with header length
        bookingList.forEach((row) => {
            const cellValue = row[headers[i].key];
            const cellLength = cellValue ? String(cellValue).length : 0;
            maxWidth = Math.max(maxWidth, cellLength);
        });
        columnWidths.push({ wch: maxWidth + 2 }); // Add a little padding
        }

        // Apply column widths to the worksheet
        ws['!cols'] = columnWidths;
    
        const borderStyle = {
            top: { style: 'thin', color: { auto: 1 } },
            bottom: { style: 'thin', color: { auto: 1 } },
            left: { style: 'thin', color: { auto: 1 } },
            right: { style: 'thin', color: { auto: 1 } },
        };

        // Apply borders to all cells
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellAddress]) continue; // Skip empty cells
            ws[cellAddress].s = {
                border: borderStyle,
            };
        }
        }
      
         // --- Formatting the Header Row ---
         const headerRange = XLSX.utils.decode_range(ws['!ref']);
         const headerRowNumber = headerRange.s.r; // Starting row index (usually 0)
         for (let c = headerRange.s.c; c <= headerRange.e.c; ++c) {
             const address = XLSX.utils.encode_cell({ r: headerRowNumber, c: c });
             ws[address].s = {
                 font: {
                     bold: true,
                     sz: 12,
                     color: { rgb: 'FFFFFF' },
                 },
                 fill: {
                     patternType: 'solid',
                     fgColor: { rgb: '19527E' },
                 },
                 alignment: {
                     horizontal: 'center',
                 },
                 border: borderStyle
             };
         };
 

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');    
        const fileName = `Danh sách đặt lịch - ${moment(fromDate).format('DD-MM-yyyy')} - ${moment(toDate).format('DD-MM-yyyy')}.xlsx`;
        XLSX.writeFile(wb, fileName);
      };
     
    const isAuthenticated = useIsAuthenticated();   
    const { accounts } = useMsal();
    const userAccount = accounts[0];
   
    return( isAuthenticated && userAccount ?
        <div>
            <Header /> 
            <div className="page-content blue-bg search-page" style={{paddingBottom: '50px'}}>
                <Container>
                    <div className="content-wrappter">
                        <h1 className="title page-title">DANH SÁCH ĐĂNG KÝ KHÁM SỨC KHỎE DOANH NGHIỆP</h1>
                        <div className="search-box">
                            <Form onSubmit={findBooking} className="search-form" >
                                <Form.Group as={Col}>
                                    <Form.Label style={{ fontWeight: 'bold' }}>Ngày khám</Form.Label>
                                    <DatePicker selectsRange selected={fromDate} onChange={onDateChanges} startDate={fromDate} endDate={toDate} className="form-control" name="booking_date" filterDate={isWeekday} dateFormat="dd/MM/yyyy" />
                                </Form.Group>                               
                                <Form.Group as={Col}>
                                    <Form.Label style={{ fontWeight: 'bold' }}>Cơ sở</Form.Label>
                                    <Form.Select className="form-control" aria-label="Chọn cơ sở" onChange={(e) => {setFacility_number(e.target.value)}}>
                                        <option value="0">Chọn cơ sở</option>
                                        <option value="1">Bernard 1</option>
                                        <option value="2">Bernard 2</option>                                        
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group  as={Col}>
                                    <Form.Label style={{ fontWeight: 'bold' }}>PID</Form.Label>
                                    <Form.Control name="person_code" type="text" value={person_code} onChange={(e) => {setPersonCode(e.target.value)}} />
                                </Form.Group>								
                                <Form.Group as={Col}>
                                    <Form.Label style={{ fontWeight: 'bold' }}>Họ và tên</Form.Label>
                                    <Form.Control name="fullName" type="text" value={fullName} onChange={(e) => {setFullName(e.target.value)}}/>
                                </Form.Group>		
                                <Form.Group as={Col} className="form-submit-group" style={{ display: 'flex', flexDirection: 'row' }}>                                    
                                    <Button type='submit' className='submit'>Tìm kiếm</Button>
                                </Form.Group>	                                					
                            </Form>
                        </div>
                        <hr/>
                        <div>
                            <div className="exportControl">
                                <Button variant="primary" onClick={handleExport}>
                                    Lưu danh sách
                                </Button>
                            </div>      
                            <BootstrapTable data={bookingList} keyField="person_code"  columns={columns} pagination={paginationFactory({ sizePerPage: 50, showTotal: true })}/>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>  
        :
        <></>          
    );
}

export default BookingReport;
